const TRUNCATE_EMAIL_CHARACTERS_TO_SHOW = 5;
const MINIMUM_LENGTH_CHATACTERS_TO_SHOW = 1;

/**
 * @deprecated Use the `truncateEmail` function from the `@pflegia/util/functions/truncate-email` module instead.
 */
export const truncateEmail = (email: string) => {
  const [localPart, domain] = email.split('@');

  const firstPart = localPart.slice(
    0,
    localPart.length > TRUNCATE_EMAIL_CHARACTERS_TO_SHOW ? TRUNCATE_EMAIL_CHARACTERS_TO_SHOW : MINIMUM_LENGTH_CHATACTERS_TO_SHOW,
  );

  return `${firstPart}...@${domain}`;
};
